import React from "react";
import styled from "styled-components";
import tw, { TwStyle } from "twin.macro";

type HeaderProps = { 
    children?: React.ReactNode;
    bgColor?: TwStyle;
    titleColor?: TwStyle; 
}

type StyledHeaderProps = {
    bgColor?: any;
}

type H1Props = {
    titleColor?: TwStyle;
}

const StyledHeader = styled.header<StyledHeaderProps>`
    ${tw`pt-10 pb-24`}
    ${(props) => props.bgColor}
`;

const StyledWrap = styled.div`
    ${tw`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}
`;

const StyledH1 = styled.h1<H1Props>`
    ${tw`text-3xl font-bold`}
    ${(props) => props.titleColor}
`;

const Header = ({ children, bgColor = tw`bg-gray-900`, titleColor = tw`text-white` }: HeaderProps) => {

    return (
        <StyledHeader bgColor={bgColor}>
            <StyledWrap >
                <StyledH1 titleColor={titleColor}>{children}</StyledH1>
            </StyledWrap>
        </StyledHeader>
    )
}

export default Header;